import { ChapterAudioDialectVariant, ChapterEditLanguageSection } from 'src/interfaces'
import { HighlightStatus } from 'src/utils/chapterSlotStatus'

const EXCLUDED_FULL_VARIANTS = new Set([
	'en-gb',
	'en-uk',
	'vi-north',
	'vi-south',
])

const EXCLUDED_VARIANT_SUFFIXES = new Set(['gb', 'uk', 'north', 'south'])

const normalizeVariant = (value?: string | null) =>
	value?.toLowerCase().trim().replace(/_/g, '-') ?? ''

export const needsHighlightRegen = (status?: HighlightStatus) =>
	status === 'none' || status === 'incorrect'

export const isExcludedHighlightRegenVariant = (
	language?: string | null,
	languageVariant?: string | null,
): boolean => {
	const variant = normalizeVariant(languageVariant)
	if (!variant) return false

	if (EXCLUDED_FULL_VARIANTS.has(variant)) return true

	const suffix = variant.includes('-')
		? variant.split('-').slice(1).join('-')
		: variant

	return EXCLUDED_VARIANT_SUFFIXES.has(suffix)
}

export const collectHighlightRegenTargets = (
	sections: ChapterEditLanguageSection[],
): ChapterAudioDialectVariant[] =>
	sections.flatMap((section) =>
		section.audioVariants.filter(
			(variant) =>
				needsHighlightRegen(variant.highlightStatus) &&
				!isExcludedHighlightRegenVariant(
					variant.language,
					variant.language_variant,
				),
		),
	)
